import { TypeEnum } from "../../shared/widgets/Form/enums/TypeEnum";
import { IForm } from "../../shared/widgets/Form/models/Form.model";

export const TeamsCreateForm: IForm[] = [
  {
    label: "Team Name",
    field: "name",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Team Description",
    field: "description",
    value: "",
    type: TypeEnum.Description,
  },
];
